import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { ItemSearchResult } from '@shared/interfaces/gridrows/item-search-result.interface';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { Cart } from '../../../core/interfaces/cart.interface';
import { FormGroup } from '@angular/forms';
import { Item } from '../../../shared/interfaces/entities/item.interface';
import { Image } from '@progress/kendo-drawing';
import { ItemImageSearchResult } from '../../../shared/interfaces/gridrows/item-image-search-result.interface';
import { ImageEntity } from "../../../shared/interfaces/entities/image.interface";

@Injectable()

export class ItemService {
  items: Cart[] = [];
  constructor(private http: HttpClient,
              private urlHelper: UrlHelperService) {

    //public state: State = { skip: 0, take: 100 };
  }

  getItems(collectionId: Number | null, organizationId: Number | null): Observable<Array<ItemSearchResult>> {
    var postData: { [k: string]: any } = {};
    postData['skip'] = 0;
    postData['take'] = 100;
    postData['collectionId'] = (collectionId == 0 ? null : collectionId);
    postData['organizationId'] = (organizationId == 0 ? null : organizationId);
    var url = this.urlHelper.getApiUrl() + "Item";
    return this.http.post<Array<ItemSearchResult>>(url, postData);
  }

  addToCart(product: any) {
    this.items.push(product);
  }

  getCartItems() {
    return this.items;
  }

  showCart(value: any) {
    var wrapper = document.getElementsByClassName('wrapper')[0];
    wrapper.classList.toggle('opened');
  }

  updateItem(data: Item): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "Item/" + data.id;
    return this.http.post<BooleanResult>(url, data);
  }

  addImage(item: number, image: Image): Observable<Boolean> { //image: ImageData, item: number,

    var postData: { [K: string]: any } = {};
    postData['image'] = image;
    postData['item'] = item;

    var url = this.urlHelper.getApiUrl() + "Item/AddImage/" + item;
    return this.http.post<Boolean>(url, postData);
  }

  getItemImages(itemId: string): Observable<Array<ImageEntity>> {
    var postData: { [k: string]: any } = {};
    postData['itemId'] = itemId;

    var url = this.urlHelper.getApiUrl() + "Item/GetItemImages/?itemId=" + itemId;
    return this.http.get<any[]>(url);
  }

  getItemUnqinumList(itemId: string): Observable<Array<ImageEntity>> {
    var postData: { [k: string]: any } = {};
    postData['itemId'] = itemId;

    var url = this.urlHelper.getApiUrl() + "Item/GetItemUniqueList/?itemId=" + itemId;
    return this.http.get<any[]>(url);
  }

  removeItemImage(contact: number): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "Item/RemoveImage/";
    return this.http.delete<BooleanResult>(url, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: contact });
  }
}
